module.exports = __webpack_public_path__ + "static/media/smart tower shot 1.59e00475.webp";